import * as types from './constants';

// Get Shopify Products
export const getShopifyProductsRequest = data => (
  { type: types.GET_SHOPIFY_PRODUCTS_REQUEST, payload: data }
);

export const getShopifyProductsDone = data => (
  { type: types.GET_SHOPIFY_PRODUCTS_DONE, payload: data }
);

export const getShopifyProductsFailed = errors => (
  { type: types.GET_SHOPIFY_PRODUCTS_FAILED, payload: errors }
);

export const getShopifyProductsReset = () => (
  { type: types.GET_SHOPIFY_PRODUCTS_RESET }
);

// Operations
// `url` is the `next` URL of the last loaded page; the request effect picks it up to load that page.
export const shopifyProductsSetPageUrl = url => (
  { type: types.SHOPIFY_PRODUCTS_SET_PAGE_URL, payload: url }
);
